import React from 'react';
import { ArrowLeft } from 'lucide-react';

// Sticky, top-left back button. Only rendered when the parent screen knows
// the user arrived from a specific previous location (e.g. the Vessel
// Refurbishment Process Map). Standalone visits to a doc/form should NOT
// render this — it's only for in-context back navigation.
const FloatingBackButton = ({ onClick, label = 'Back to Process Map' }) => (
  <button
    type="button"
    onClick={onClick}
    className="fixed top-4 left-4 z-50 flex items-center gap-2 px-4 py-2 rounded-lg pvs-glass pvs-glass-hover border border-pvs-accent/40 shadow-pvs-glow"
    title={label}
  >
    <ArrowLeft className="w-5 h-5 text-white" />
    <span className="text-white text-sm font-semibold">{label}</span>
  </button>
);

export default FloatingBackButton;
